import React from "react";

const PlanetLanding = (props) => {
  return (
    <svg
      width={215}
      height={215}
      viewBox="0 0 215 215"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="a"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={215}
        height={215}
      >
        <circle cx={107.5} cy={107.5} r={107.5} fill="#5289E3" />
      </mask>
      <g mask="url(#a)">
        <circle cx={107.5} cy={107.5} r={107.5} fill="#5289E3" />
        <path
          d="M29.63 31.95c77.104 38.878 121.812 44.75 190.695 87.652-.754 13.168-2.468 20.145-6.884 32.163-87.087-27.568-194.138-106.03-194.138-106.03S24.735 36.08 29.63 31.95z"
          fill="#5ABAFA"
        />
        <path
          d="M70.746 0s36.64 15.703 48.134 22.433c11.495 6.73 28.893 18.064 49.212 22.807 15.83 17.422 26.346 19.791 44.542 26.547l5.029 16.077s-47.416-16.077-54.241-16.077c-6.825 0-42.027-25.05-50.289-24.303-8.262.748-38.462-22.077-58.551-41.128L70.746 0zM2.749 71.888c41.702 12.62 65.026 21.66 106.059 57.056 32.579 30.359 53.945 39.481 94.876 48.55l-20.562 20.2c-34.22-6.914-52.175-15.843-81.89-41.109-38.623-31.307-61.5-44.672-103.895-63.08L2.75 71.889z"
          fill="#4AD1F0"
        />
        <path
          d="M-7.322 120.48s42.084 15.345 40.171 26.47c-1.912 11.126 45.528 36.445 49.354 34.143 3.826-2.302 74.221 32.992 74.221 32.992l-32.902 6.906s-37.876-22.634-45.145-19.949c-7.27 2.685-52.797-27.238-52.414-32.608.383-5.371-28.694-29.54-28.694-29.54l-4.591-18.414z"
          fill="#5ABAFA"
        />
      </g>
    </svg>
  );
};

export default PlanetLanding;
